import React from "react";

import { useIntl } from "react-intl";

import LabeledInfo from "Components/LabeledInfo";

import type { WorkerTree } from "src/organization/common/containers/ServicesDisplay/util/serviceGraph";

type WorkerInfosProps = {
  metadata: WorkerTree["metadata"];
  isSizingApiEnabled?: boolean;
  cpu: number;
  ram: number;
  disk: number;
  instances: number;
  profileLabel: string;
};

const WorkerInfos = ({
  metadata,
  isSizingApiEnabled,
  cpu,
  ram,
  disk,
  instances,
  profileLabel
}: WorkerInfosProps) => {
  const intl = useIntl();

  const instanceCount = metadata?.instancesCount;

  if (isSizingApiEnabled) {
    return (
      <>
        <LabeledInfo
          gridColumn="auto"
          label={intl.formatMessage({ id: "cpu_dialog" })}
          value={cpu ? `${cpu} CPU` : intl.formatMessage({ id: "unknown" })}
        />
        <LabeledInfo
          gridColumn="auto"
          label={intl.formatMessage({ id: "ram_dialog" })}
          value={ram ? `${ram} GB` : intl.formatMessage({ id: "unknown" })}
        />
        <LabeledInfo
          gridColumn="auto"
          label={intl.formatMessage({ id: "disk_dialog" })}
          value={`${disk} GB`}
        />
        <LabeledInfo
          gridColumn="auto"
          label={intl.formatMessage({ id: "instances_dialog" })}
          value={instances ?? intl.formatMessage({ id: "unknown" })}
        />
        <LabeledInfo
          gridColumn="auto"
          label={intl.formatMessage({ id: "profile_dialog" })}
          value={
            profileLabel?.toLocaleUpperCase() ??
            intl.formatMessage({ id: "unknown" })
          }
        />
      </>
    );
  }

  return (
    <>
      <LabeledInfo
        gridColumn="auto"
        label={intl.formatMessage({ id: "version" })}
        value={
          metadata.type.split(":")[1] || intl.formatMessage({ id: "unknown" })
        }
        shouldCapitalize={false}
      />
      <LabeledInfo
        gridColumn="auto"
        label={intl.formatMessage({ id: "size" })}
        value={metadata.size || intl.formatMessage({ id: "unknown" })}
      />
      <LabeledInfo
        gridColumn="auto"
        label={intl.formatMessage({ id: "disk" })}
        value={metadata.disk || intl.formatMessage({ id: "unknown" })}
      />
      {instanceCount && (
        <LabeledInfo
          gridColumn="auto"
          label={intl.formatMessage({ id: "instances" })}
          value={instanceCount}
        />
      )}
    </>
  );
};

export default WorkerInfos;
